module.exports = __webpack_public_path__ + "static/20-b618f31c5a9bde7f59363db3c8073aa9.jpg";